module.exports = __webpack_public_path__ + "img/recart_logo.cd1eb38b.png";